import { Box, Text } from "@chakra-ui/react";

const CONFIG = {
  success: {
    bg: "linear-gradient(135deg, #004a33 0%, #006b4b 100%)",
    icon: "✅",
    shadow: "0 16px 40px rgba(0,74,51,0.3)",
  },
  warning: {
    bg: "linear-gradient(135deg, #92400e 0%, #d97706 100%)",
    icon: "⚠️",
    shadow: "0 16px 40px rgba(146,64,14,0.25)",
  },
  error: {
    bg: "linear-gradient(135deg, #991b1b 0%, #dc2626 100%)",
    icon: "❌",
    shadow: "0 16px 40px rgba(153,27,27,0.25)",
  },
  info: {
    bg: "linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)",
    icon: "ℹ️",
    shadow: "0 16px 40px rgba(30,58,138,0.25)",
  },
};

export function BoozenToast({ type = "success", title, description, onClose }) {
  const s = CONFIG[type];
  return (
    <Box
      bg={s.bg}
      color="white"
      borderRadius="20px"
      p="18px 22px"
      display="flex"
      alignItems="center"
      gap="14px"
      boxShadow={s.shadow}
      border="1px solid rgba(255,255,255,0.12)"
      maxW="400px"
      w="100%"
    >
      <Box
        w="44px"
        h="44px"
        borderRadius="50%"
        bg="rgba(255,255,255,0.15)"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexShrink={0}
        fontSize="20px"
      >
        {s.icon}
      </Box>

      <Box flex={1} minW={0}>
        <Text fontWeight="900" fontSize="15px" lineHeight="1.3" mb={description ? "3px" : 0}>
          {title}
        </Text>
        {description && (
          <Text fontSize="12px" opacity="0.85" lineHeight="1.5">
            {description}
          </Text>
        )}
      </Box>

      {onClose && (
        <Box
          as="button"
          onClick={onClose}
          w="28px"
          h="28px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          borderRadius="50%"
          bg="rgba(255,255,255,0.12)"
          border="none"
          cursor="pointer"
          color="white"
          fontSize="16px"
          flexShrink={0}
          transition="background 0.15s"
          _hover={{ bg: "rgba(255,255,255,0.22)" }}
        >
          ×
        </Box>
      )}
    </Box>
  );
}
